import styled from "styled-components";

export const EditTournamentWrapper = styled.div`
  position: relative;
  width: 1065px;
  height: 901px;
  border-radius: 13px;
  background: #fff;
  padding: 43px 40px 60px;
  box-sizing: border-box;
`;

export const EditTournamentHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-bottom: 50px;
`;

export const EditTournamentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > img {
    cursor: pointer;
  }
`;

export const EditTournamentHeaderButtonWrapper = styled.div`
  display: flex;
  gap: 20px;

  > .button {
    width: 109px;
    height: 50px;
    border-radius: 15px;
    background: #6436e7;
    font-family: Pretendard;
    font-weight: 700;
    font-style: Bold;
    font-size: 15px;
    line-height: 50px;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
  }
`;

export const EditTournamentDropBoxWrapper = styled.div`
  height: 50px;
  padding: 0 20px;
  border-radius: 15px;
  gap: 5px;
  border: 1px solid #b7b7b7;
  background: #ffffff;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  width: auto;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 15px;
  text-align: center;

  > img {
    width: 8px;
    height: 7px;
  }
`;

export const EditTournamentDropBoxItemWrapper = styled.div`
  position: absolute;
  border-radius: 8px;
  gap: 4px;
  padding: 12px;
  box-shadow: 0px 0px 8px 0px #0000001f;
  top: 55px;
  left: 0;
  z-index: 1000;
  background: #fff;
  display: flex;
  flex-direction: column;
  width: auto;
`;

export const EditTournamentDropBoxItem = styled.div<{ selected: boolean }>`
  white-space: nowrap;
  width: auto;
  height: 30px;
  border-radius: 15px;
  padding: 8px 12px;
  box-sizing: border-box;
  line-height: 15px;
  text-align: center;
  gap: 2px;
  border: 1px solid var(--Black-100, #f0f0f0);
  gap: 8px;
  display: flex;
  justify-content: space-between;

  ${(p) =>
    p.selected
      ? `
    background: var(--Purple-300, #6436e7);
    color: #fff;
    `
      : ""}

  svg path {
    stroke: ${(p) => (p.selected ? "#fff" : "var(--Black-400, #444)")};
  }
`;

export const EditTournamentTabWrapper = styled.div`
  width: 100%;
  height: 44px;
  border-radius: 26.98px;
  padding: 6px 17px;
  box-sizing: border-box;
  background: #2f3332;
  display: flex;
  gap: 17px;
`;

export const EditTournamentTabItem = styled.div<{ selected: boolean }>`
  flex: 1;
  height: 32px;
  border-radius: 30.35px;
  box-sizing: border-box;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 13.49px;
  line-height: 32px;
  text-align: center;
  color: ${(p) => (p.selected ? "#fff" : "#B7B7B7")};
  background: ${(p) => (p.selected ? "#6436e7" : "none")};
  cursor: pointer;
`;

export const EditTournamentButtonWrapper = styled.div`
  position: absolute;
  bottom: 60px;
  display: flex;
  gap: 20px;

  > .button {
    width: 482px;
    height: 59px;
    border-radius: 20px;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 20.23px;
    line-height: 59px;
    text-align: center;
    background: #969696;
    color: #fff;
    cursor: pointer;
  }

  > .purple {
    background: #6436e7;
  }
`;

export const EditTournamentCheckBox = styled.div`
  position: relative;

  > img {
    position: absolute;
    top: 7px;
    left: 5px;
    pointer-events: none;
  }

  input[type="checkbox"] {
    appearance: none;
    width: 22px;
    height: 22px;
    border: 2px solid #d9d9d9;
    background-color: #fff;
    vertical-align: bottom;
    cursor: pointer;
    margin: 0;
    border: 1.3px solid #d9d9d9;
  }

  input[type="checkbox"]:checked {
    border: 1px solid #d9d9d9;
    background-color: #7f25fb;
  }
`;
